import React, { useEffect, useState } from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import Select from 'react-select';
import API from '../../api/axios';

const SelectState = React.memo(
  ({
    isMulti,
    onSelect,
    placeholder,
    city,
    localState,
    isDisabled,
    mostUse,
    isDest,
    width,
    height,
    cityName,
    ...rest
  }) => {
    const [cities, setCities] = useState(null);
    const loadCities = async () => {
      let filter = Array();
      mostUse !== undefined && filter.push(`mostUse=${mostUse}`);
      isDest !== undefined && filter.push(`isDest=${isDest}`);
      !!localState && filter.push(`state=${localState}`);
      // let query = filter.join('&');
      // const url = `/api/v1/admin/city/list?${query}`;
      try {
        // const response = await API.get(url);
        const respone = await fetch('/cities.json');
        const data = await respone.json();
        // setCities(response.data);
        if (localState) {
          const res = data.filter((item) => item.state._id === localState);
          return setCities(res);
        }
        return setCities(data);
      } catch (err) {
        console.error(err);
      }
    };
    const handleSelectCity = (selected) => {
      const city = cities.find((city) => city._id === selected.value);
      onSelect(city);
    };

    useEffect(() => {
      loadCities();
    }, [localState]);
    useEffect(() => {
      if (cityName) {
        const city = cities.find((c) => c.title === cityName);
        onSelect(city);
      }
    }, [cityName]);

    return (
      <>
        {!!cities ? (
          <Select
            options={cities.map((city) => ({
              label: city.title,
              value: city._id,
            }))}
            isMulti={isMulti}
            isSearchable={true}
            placeholder={!!placeholder ? placeholder : 'انتخاب شهر ...'}
            value={city ? { label: city.title, value: city._id } : null}
            onChange={(option) => handleSelectCity(option)}
            noOptionsMessage={() => 'شهری یافت نشد'}
            isDisabled={isDisabled ? isDisabled : false}
            styles={{
              menu: (provided, state) => ({
                ...provided,
                zIndex: 2,
              }),
            }}
            {...rest}
          />
        ) : (
          <Skeleton
            height={56}
            animation="wave"
            variant="rect"
            width={width ? width : '100%'}
          />
        )}
      </>
    );
  }
);

export default SelectState;
